import { useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useFormClear } from '@/shared/hooks/useFormClear.ts';
import { AutomaticProductsFormValues } from '../schema/getAutomaticProductsFormSchema.ts';

export function useFormLocations(methods: UseFormReturn<AutomaticProductsFormValues>) {
    const { getValues, clearField } = useFormClear(methods);

    const clearLocations = useCallback(
        (organizationId: number) => {
            const loadingLocation = getValues('loadingLocation');
            const unloadingLocation = getValues('unloadingLocation');

            if (loadingLocation?.location.organizationId === organizationId) {
                clearField('loadingLocation');
            }
            if (unloadingLocation?.location.organizationId === organizationId) {
                clearField('unloadingLocation');
            }
        },
        [getValues, clearField]
    );

    return { clearLocations };
}
